__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "appsec-admin-setting-react-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "2.8.2", () => (Promise.all([__webpack_require__.e(879), __webpack_require__.e(606)]).then(() => (() => (__webpack_require__(2260))))));
			register("@tanstack/react-query", "5.81.5", () => (Promise.all([__webpack_require__.e(205), __webpack_require__.e(318), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(1205))))));
			register("lucide-react", "0.525.0", () => (Promise.all([__webpack_require__.e(195), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(2195))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(961))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(468), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(1468))))));
			register("react-router-dom", "7.6.3", () => (Promise.all([__webpack_require__.e(488), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(225)]).then(() => (() => (__webpack_require__(3488))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};